import webApi from '../../WebApi/WebApi';


//Manual Handling list
export const getAllManualHandlingList = async () => {
    return await webApi.get(`/info-pages/slug/manual-for-handling-client-complaints-and-conflict-resolution`);
}